interface NumericInputOptions {
  min?: number;
  max?: number;
  decimal?: boolean;
  disabled?: boolean;
}

export function numericInput(
  node: HTMLInputElement,
  options?: NumericInputOptions,
): {
  destroy: () => void;
} {
  if (options && options.disabled) return { destroy() {} };
  const min = options?.min ?? Number.MIN_SAFE_INTEGER;
  const max = options?.max ?? Number.MAX_SAFE_INTEGER;
  const regexp = options?.decimal ? /[^\d.\-,]/g : /[^0-9]/g;

  function handleInput(event: Event) {
    const target = event.target as HTMLInputElement;
    let newValue = target.value.replace(regexp, "");
    if (newValue === "") {
      target.value = newValue;
      return;
    }
    const numericValue = parseInt(newValue);
    if (numericValue < min) {
      newValue = min.toString();
    } else if (numericValue > max) {
      newValue = max.toString();
    }
    target.value = newValue;
  }

  node.addEventListener("input", handleInput);

  return {
    destroy() {
      node.removeEventListener("input", handleInput);
    },
  };
}
